import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b91690ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "heading-title" }, "Benefits", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "heading-subtitle" }, " Below are the benefit plans available to you. To enroll in a plan, click Enroll. A summary of the coverage options will appear, along with the effective date and monthly premium amount. To forgo a benefit plan, click Waive and you will not be enrolled in that plan. Once you've made your selections, click SAVE & NEXT to move to the next step. ", -1))
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "accordion-header collapsed" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "buttons" }
const _hoisted_8 = ["onClick", "disabled"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["id"]
const _hoisted_12 = { class: "insurance-form" }
const _hoisted_13 = { class: "coverage-details" }
const _hoisted_14 = { class: "coverage-info" }
const _hoisted_15 = { class: "info" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "Effective Date Of Coverage:", -1))
const _hoisted_17 = { class: "info-value text-number" }
const _hoisted_18 = { class: "coverage-info" }
const _hoisted_19 = {
  key: 0,
  class: "info"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "Carrier:", -1))
const _hoisted_21 = { class: "info-value" }
const _hoisted_22 = {
  key: 0,
  class: "document-container"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "document-label" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["id"]
const _hoisted_27 = { class: "document-list" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 1,
  class: "benefit-title"
}
const _hoisted_30 = { key: 2 }
const _hoisted_31 = {
  key: 0,
  class: "document-inline",
  style: {"margin-left":"12px"}
}
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "document-label" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["id"]
const _hoisted_36 = { class: "document-list" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "benefit-title" }, "Coverage Options", -1))
const _hoisted_39 = {
  key: 3,
  class: "coverage-options"
}
const _hoisted_40 = { class: "option single-type" }
const _hoisted_41 = { class: "option-price" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "month", -1))
const _hoisted_43 = { class: "effective-rate-coverage" }
const _hoisted_44 = { class: "effective-date" }
const _hoisted_45 = { class: "effective-rate" }
const _hoisted_46 = {
  key: 0,
  class: "effective-rate-coverage"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "effective-date subsidy-padding" }, " Includes subsidy of ", -1))
const _hoisted_48 = { class: "effective-rate" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "thin-line" }, null, -1))
const _hoisted_50 = {
  key: 4,
  class: "coverage-options"
}
const _hoisted_51 = { class: "option single-type" }
const _hoisted_52 = { class: "option-price" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "month", -1))
const _hoisted_54 = { class: "effective-rate-coverage" }
const _hoisted_55 = { class: "effective-date" }
const _hoisted_56 = { class: "effective-rate" }
const _hoisted_57 = {
  key: 0,
  class: "effective-rate-coverage"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "effective-date subsidy-padding" }, " Includes subsidy of ", -1))
const _hoisted_59 = { class: "effective-rate" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "thin-line" }, null, -1))
const _hoisted_61 = {
  key: 5,
  class: "coverage-options"
}
const _hoisted_62 = { class: "option-title" }
const _hoisted_63 = { class: "option-price" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "month", -1))
const _hoisted_65 = { class: "effective-rate-coverage" }
const _hoisted_66 = { class: "effective-date" }
const _hoisted_67 = { class: "effective-rate" }
const _hoisted_68 = {
  key: 0,
  class: "effective-rate-coverage"
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "effective-date subsidy-padding" }, " Includes subsidy of ", -1))
const _hoisted_70 = { class: "effective-rate" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "thin-line" }, null, -1))
const _hoisted_72 = ["id", "onUpdate:modelValue", "onChange", "disabled"]
const _hoisted_73 = ["innerHTML"]
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "benefit-title" }, "Who Does This Plan Need To Cover?", -1))
const _hoisted_75 = { class: "plan-coverage" }
const _hoisted_76 = { class: "person" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "form-check-label",
  for: "self"
}, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "checkbox",
    class: "form-check-input",
    id: "self",
    checked: "",
    disabled: ""
  })
], -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "avatar" }, null, -1))
const _hoisted_79 = { class: "person-details" }
const _hoisted_80 = { class: "person-name" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "person-subtext" }, "You", -1))
const _hoisted_82 = {
  class: "form-check-label",
  for: "self"
}
const _hoisted_83 = ["onUpdate:modelValue", "id", "onChange", "disabled"]
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "avatar" }, null, -1))
const _hoisted_85 = { class: "person-details" }
const _hoisted_86 = { class: "person-name" }
const _hoisted_87 = { class: "person-subtext" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToolTip = _resolveComponent("ToolTip")!
  const _component_AppFooter = _resolveComponent("AppFooter")!
  const _component_ApprovalModal = _resolveComponent("ApprovalModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      (_ctx.validationMsg)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "alert alert-danger",
            innerHTML: _ctx.validationMsg
          }, null, 8, _hoisted_4))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.benefits, (benefit, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: benefit.benefitId,
          class: _normalizeClass(["accordion", {
        active: benefit.isOpen,
        enrolled: benefit.isWaived === false,
      }])
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: _normalizeClass(["title", { waived: benefit.isWaived === true }]),
              onClick: ($event: any) => (_ctx.toggleAccordionOpen(index))
            }, _toDisplayString(benefit.planDescription ?? benefit.bundleName), 11, _hoisted_6),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                class: _normalizeClass(["enroll-button", { active: benefit.isWaived === false }]),
                onClick: ($event: any) => (_ctx.toggleAccordion(index, _ctx.action.enroll)),
                disabled: !_ctx.canModifyBenefit(benefit)
              }, [
                _createTextVNode(" Enroll "),
                (!_ctx.canModifyBenefit(benefit))
                  ? (_openBlock(), _createBlock(_component_ToolTip, {
                      key: 0,
                      tooltipText: "Enrollment is restricted. You may only change or waive existing enrollments."
                    }))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_8),
              _createElementVNode("button", {
                class: _normalizeClass(["waive-button", { active: benefit.isWaived === true }]),
                onClick: ($event: any) => (_ctx.toggleAccordion(index, _ctx.action.waive))
              }, " Waive ", 10, _hoisted_9)
            ]),
            _createElementVNode("button", {
              class: _normalizeClass(["arrow no-btn", {
            collapsed: !benefit.isOpen,
          }]),
              "aria-label": "arrow",
              onClick: ($event: any) => (_ctx.toggleAccordionOpen(index))
            }, null, 10, _hoisted_10)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["accordion-content collapse", {
          show: benefit.isOpen,
          collapse: !benefit.isOpen,
        }]),
            id: 'flush-' + benefit.benefitId
          }, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.effectiveDate(_ctx.benefitEffectiveDate)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  (benefit.benefitBundleId == null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _hoisted_20,
                        _createElementVNode("span", _hoisted_21, _toDisplayString(benefit.carrierName), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (benefit.documents && benefit.documents.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("div", {
                      class: "document-header",
                      onClick: ($event: any) => (_ctx.toggleDocuments(index))
                    }, [
                      _createElementVNode("span", _hoisted_24, "Documents (" + _toDisplayString(benefit.documents.length) + ")", 1),
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["document-arrow", { collapsed: !benefit.documentsOpen }]),
                        onClick: _withModifiers(($event: any) => (_ctx.toggleDocuments(index)), ["stop"]),
                        "aria-label": "Toggle documents"
                      }, null, 10, _hoisted_25)
                    ], 8, _hoisted_23),
                    _createElementVNode("div", {
                      class: _normalizeClass(["document-section collapse", { show: benefit.documentsOpen }]),
                      id: 'document-section-' + benefit.benefitId
                    }, [
                      _createElementVNode("ul", _hoisted_27, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(benefit.documents, (doc, docIndex) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: "document-item",
                            key: 'document-' + docIndex
                          }, [
                            _createElementVNode("a", {
                              class: "a document-link",
                              onClick: ($event: any) => (_ctx.downloadDocument(doc.custBenefitDocumentID!))
                            }, [
                              _createTextVNode(_toDisplayString(doc.documentName) + " ", 1),
                              (doc.description)
                                ? (_openBlock(), _createBlock(_component_ToolTip, {
                                    key: 0,
                                    tooltipText: doc.description
                                  }, null, 8, ["tooltipText"]))
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_28)
                          ]))
                        }), 128))
                      ])
                    ], 10, _hoisted_26)
                  ]))
                : _createCommentVNode("", true),
              (benefit.benefitBundleId != null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, " Benefits "))
                : _createCommentVNode("", true),
              (benefit.benefitBundleId != null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(benefit.benefits, (details, detailsIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: details.benefitId,
                        class: "plan-detail-title"
                      }, [
                        _createTextVNode(_toDisplayString(details.planName) + " (" + _toDisplayString(details.carrierName) + ") ", 1),
                        (details.documents && details.documents.length)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
                              _createElementVNode("span", {
                                class: "document-header",
                                style: {"display":"inline-flex","align-items":"center","cursor":"pointer"},
                                onClick: ($event: any) => (_ctx.toggleBundleDocuments(benefit, detailsIndex))
                              }, [
                                _createElementVNode("span", _hoisted_33, _toDisplayString(details.documents.length) + " Documents ", 1),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: _normalizeClass(["document-arrow", {
                      collapsed: !benefit.benefits[detailsIndex].documentsOpen,
                    }]),
                                  onClick: _withModifiers(($event: any) => (_ctx.toggleBundleDocuments(benefit, detailsIndex)), ["stop"]),
                                  "aria-label": "Toggle documents",
                                  style: {"margin-left":"4px"}
                                }, null, 10, _hoisted_34)
                              ], 8, _hoisted_32),
                              _createElementVNode("div", {
                                class: _normalizeClass(["document-section collapse", {
                    show: !benefit.benefits[detailsIndex].documentsOpen,
                  }]),
                                id: 'bundle-document-section-' + details.benefitId,
                                style: {"margin-top":"0.5rem"}
                              }, [
                                _createElementVNode("ul", _hoisted_36, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(details.documents, (doc, docIndex) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      class: "document-item",
                                      key: 'bundle-document-' + docIndex
                                    }, [
                                      _createElementVNode("a", {
                                        class: "a document-link",
                                        onClick: _withModifiers(($event: any) => (
                          _ctx.downloadDocument(doc.custBenefitDocumentID!)
                        ), ["stop"])
                                      }, _toDisplayString(doc.fileName), 9, _hoisted_37)
                                    ]))
                                  }), 128))
                                ])
                              ], 10, _hoisted_35)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _hoisted_38,
              (benefit.benefitRateTypeId === _ctx.common.benefit.single)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createElementVNode("label", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _createTextVNode(" $" + _toDisplayString(_ctx.helper.formatNumber(benefit.singleMonthlyPremiumRate)) + "/", 1),
                        _hoisted_42
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(benefit.singleRates, (singleRate, index) => {
                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("div", _hoisted_44, " Rate as of " + _toDisplayString(_ctx.helper.formatDate(singleRate.effectiveDate!)), 1),
                            _createElementVNode("div", _hoisted_45, " $" + _toDisplayString(_ctx.helper.formatNumber(singleRate.monthlyPremiumRate!)), 1)
                          ]),
                          (singleRate.subsidyAmount)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                _hoisted_47,
                                _createElementVNode("div", _hoisted_48, " $" + _toDisplayString(_ctx.helper.formatNumber(
                        singleRate.subsidyAmount < 0
                          ? singleRate.subsidyAmount * -1
                          : singleRate.subsidyAmount
                      )), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _hoisted_49
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (benefit.benefitRateTypeId === _ctx.common.benefit.unique)
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    _createElementVNode("label", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _createTextVNode(" $" + _toDisplayString(_ctx.helper.formatNumber(benefit.uniqueMonthlyPremiumRate)) + "/", 1),
                        _hoisted_53
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(benefit.uniqueRates, (uniqueRate, index) => {
                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("div", _hoisted_55, " Rate as of " + _toDisplayString(_ctx.helper.formatDate(uniqueRate.effectiveDate!)), 1),
                            _createElementVNode("div", _hoisted_56, " $" + _toDisplayString(_ctx.helper.formatNumber(uniqueRate.monthlyPremiumRate!)), 1)
                          ]),
                          (uniqueRate.subsidyAmount)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                _hoisted_58,
                                _createElementVNode("div", _hoisted_59, " $" + _toDisplayString(_ctx.helper.formatNumber(
                        uniqueRate.subsidyAmount < 0
                          ? uniqueRate.subsidyAmount * -1
                          : uniqueRate.subsidyAmount
                      )), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _hoisted_60
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (benefit.benefitRateTypeId === _ctx.common.benefit.tier)
                ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(benefit.tiers, (option, optionIndex) => {
                      return (_openBlock(), _createElementBlock("label", {
                        class: _normalizeClass(["option", { active: option.isSelected }]),
                        key: 'option-' + option.tierCodeId
                      }, [
                        _createElementVNode("div", _hoisted_62, [
                          _createTextVNode(_toDisplayString(option.tierLevelName) + " ", 1),
                          (!_ctx.canModifyBenefit(benefit))
                            ? (_openBlock(), _createBlock(_component_ToolTip, {
                                key: 0,
                                tooltipText: "Enrollment is restricted. You may only change or waive existing enrollments."
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_63, [
                          _createTextVNode(" $" + _toDisplayString(_ctx.helper.formatNumber(option.monthlyPremiumRate!)) + "/", 1),
                          _hoisted_64
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(option.tierRates, (tierRate) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: 'tierrate-' + tierRate.employeeRate
                          }, [
                            _createElementVNode("div", _hoisted_65, [
                              _createElementVNode("div", _hoisted_66, " Rate as of " + _toDisplayString(_ctx.helper.formatDate(tierRate.effectiveDate!)), 1),
                              _createElementVNode("div", _hoisted_67, " $" + _toDisplayString(_ctx.helper.formatNumber(tierRate.monthlyPremiumRate!)), 1)
                            ]),
                            (tierRate.subsidyAmount)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                  _hoisted_69,
                                  _createElementVNode("div", _hoisted_70, " $" + _toDisplayString(_ctx.helper.formatNumber(
                        tierRate.subsidyAmount < 0
                          ? tierRate.subsidyAmount * -1
                          : tierRate.subsidyAmount
                      )), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _hoisted_71
                          ]))
                        }), 128)),
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          class: "form-check-input",
                          id: 'member-' + option.tierCodeId + '-' + benefit.benefitId,
                          "onUpdate:modelValue": ($event: any) => ((option.isSelected) = $event),
                          onChange: ($event: any) => (
                  _ctx.tierSelected(
                    option.isSelected!,
                    option.employeeRate!,
                    benefit,
                    index,
                    optionIndex
                  )
                ),
                          disabled: !_ctx.canModifyBenefit(benefit)
                        }, null, 40, _hoisted_72), [
                          [_vModelCheckbox, option.isSelected]
                        ])
                      ], 2))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (benefit.dependentValMsg)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 6,
                    class: "dependent-val-msg",
                    innerHTML: benefit.dependentValMsg
                  }, null, 8, _hoisted_73))
                : _createCommentVNode("", true),
              _hoisted_74,
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("label", _hoisted_76, [
                  _hoisted_77,
                  _hoisted_78,
                  _createElementVNode("div", _hoisted_79, [
                    _createElementVNode("div", _hoisted_80, _toDisplayString(_ctx.profile.firstName) + " " + _toDisplayString(_ctx.profile.lastName), 1),
                    _hoisted_81
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(benefit.dependents, (dependent) => {
                  return (_openBlock(), _createElementBlock("label", {
                    class: "person",
                    key: 'dependent-' + dependent.electionDependentId
                  }, [
                    _createElementVNode("div", _hoisted_82, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": ($event: any) => ((dependent.isSelected) = $event),
                        type: "checkbox",
                        class: "form-check-input",
                        id: 
                    'dependent-' +
                    dependent.electionDependentId +
                    '-' +
                    (benefit.benefitId ?? benefit.benefitBundleId)
                  ,
                        onChange: ($event: any) => (_ctx.changeDependent(dependent.isSelected!, index)),
                        disabled: dependent.disabled
                      }, null, 40, _hoisted_83), [
                        [_vModelCheckbox, dependent.isSelected]
                      ])
                    ]),
                    _hoisted_84,
                    _createElementVNode("div", _hoisted_85, [
                      _createElementVNode("div", _hoisted_86, _toDisplayString(dependent.firstName) + " " + _toDisplayString(dependent.lastName), 1),
                      _createElementVNode("div", _hoisted_87, _toDisplayString(dependent.relationshipName), 1)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ], 10, _hoisted_11)
        ], 2))
      }), 128))
    ]),
    _createVNode(_component_AppFooter, {
      "save-btn-txt": _ctx.common.saveNext,
      "is-form-invalid": !_ctx.areBenefitsValid(),
      "is-submit-disabled": false,
      onSubmitHandler: _ctx.submitHandler,
      "tool-tip": _ctx.benefitsValidationMessage
    }, null, 8, ["save-btn-txt", "is-form-invalid", "onSubmitHandler", "tool-tip"]),
    _createVNode(_component_ApprovalModal, {
      title: "",
      body: _ctx.approvalModalText,
      visible: _ctx.isApprovalModalVisible,
      approveButtonText: "Submit",
      cancelButtonText: "Cancel",
      onClose: _ctx.closeModal,
      onApprove: _ctx.continueSubmitAfterRequiredFileCheck
    }, null, 8, ["body", "visible", "onClose", "onApprove"])
  ], 64))
}